module.exports = __webpack_public_path__ + "assets/img/ruleD.87ca23b1.png";